export const NAV_BAR_CONTENT_KEY = ["navBarContent"];
export const INITIAL_ANALYSIS_IN_PROGRESS_KEY = ["initialAnalysisInProgress"];
